// Mirrors the server-side window in worker/src/lib/uploadWindow.ts. Shared by
// Hero (the attention-grabbing CTA) and Gallery (the actual upload section) so
// both agree on when uploads are open. `uploads_open_at`/`uploads_close_at` are
// explicit overrides set in Settings; falling back to the day-offset default
// when either is left unset.
const UPLOAD_WINDOW_BEFORE_DAYS = 1;

export function getUploadWindow(wedding) {
  const windowOpensAt = wedding?.uploads_open_at
    ? new Date(wedding.uploads_open_at)
    : wedding?.data_evento
    ? new Date(new Date(wedding.data_evento).getTime() - UPLOAD_WINDOW_BEFORE_DAYS * 86_400_000)
    : null;
  const windowClosesAt = wedding?.uploads_close_at ? new Date(wedding.uploads_close_at) : null;
  const uploadsOpen =
    !!wedding?.uploads_force_open ||
    ((!windowOpensAt || Date.now() >= windowOpensAt.getTime()) && (!windowClosesAt || Date.now() <= windowClosesAt.getTime()));
  return { uploadsOpen, windowOpensAt, windowClosesAt };
}
